import { render, staticRenderFns } from "./add-select.vue?vue&type=template&id=66e7e6c2&"
import script from "./add-select.vue?vue&type=script&lang=ts&"
export * from "./add-select.vue?vue&type=script&lang=ts&"
import style0 from "./add-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports